import React from "react";
import { AGENTS } from "../../consts/tables";
import AgentInfo from "./AgentInfo";
import { browserHistory } from "react-router";
import CRUD from "../CRUD/CRUD";
import FirmDrawer from "../FirmDrawer/FirmDrawer";
import Drawer from "../Drawer";
import { getData, manageData } from "../../requests/CRUD";

export default class CRUDAgent extends React.Component {
  drawerComponentRef;

  constructor(props) {
    super(props);

    this.state = {
      data: null,
      original: null,
      isBusy: null,
      error: null,
      success: null,
      newFirm: false,
      errorTabs: [],
      currentTab: 0,
      viewMode: this.props.edit || false,
      showDrawer: false,
      addNewItemType: null,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
    this.saveData = this.saveData.bind(this);
    this.addNewItem = this.addNewItem.bind(this);
    this.savedNewFirm = this.savedNewFirm.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.id !== nextProps.params.id) {
      this.fetch(nextProps.params.id);
    }
  }

  componentDidMount() {
    this.fetch(this.props.params.id);
  }

  closeDrawer() {
    this.setState({ showDrawer: false });
  }

  savedNewFirm(newData) {
    // select the new item id & close drawer
    const key = this.state.addNewItemType;
    const state = {
      data: { ...this.state.data, [key]: newData.ARCIMEDES_ROW_ID },
      newFirm: newData,
    };
    this.setState(state, () => this.toggleDrawer());
  }

  fetch(id) {
    this.setState({
      data: null,
      error: null,
      success: null,
    });

    if (id === undefined) {
      this.setState({ data: {} });
      return;
    }

    getData({
      tableCode: AGENTS,
      options: {
        filter: [
          {
            text: id,
            code: "ARCIMEDES_ROW_ID",
            type: "exact",
          },
        ],
      },
    }).then((res) => {
      if (res && res.success && Array.isArray(res.data) && res.data.length) {
        this.setState({
          data: res.data[0],
          original: { ...res.data[0] },
          error: null,
        });
      } else {
        this.setState({
          data: false,
          error: res.message ? res.message : "Unidentified Error",
        });
      }
    });
  }

  handleSubmit(e) {
    e.preventDefault();

    if (this.state.viewMode) this.setState({ viewMode: false });

    if (
      this.state.isBusy ||
      this.state.data.FIRST_NAME === "" ||
      this.state.data.LAST_NAME === "" ||
      this.state.viewMode === true
    )
      return;

    this.setState({ viewMode: true }, () => this.saveData());
  }

  handleChangeInput(key, value) {
    this.setState({
      data: Object.assign(this.state.data, {
        [key]: value,
      }),
    });
  }

  saveData() {
    if (this.state.isBusy) return;

    this.setState({
      isBusy: true,
      error: null,
      success: null,
    });

    return manageData({ tableCode: AGENTS, data: [this.state.data] }).then(
      (res) => {
        if (res && res.success) {
          this.setState(
            {
              isBusy: false,
              success: "Saved",
            },
            () => {
              if (!this.props.edit) {
                browserHistory.push({
                  pathname: `/agent/${res.data[0].ARCIMEDES_ROW_ID}`,
                });
              }
            }
          );

          window.scrollTo(0, 0);
        } else {
          this.setState({
            isBusy: null,
            error: res && res.message ? res.message : "Unspecified error",
          });
        }
      }
    );
  }

  handleChangeDropdown(query, queryType, x, key) {
    this.setState({
      data: Object.assign(this.state.data, {
        [key]: query[key],
      }),
    });
  }

  toggleDrawer() {
    this.setState((prevState) => ({ showDrawer: !prevState.showDrawer }));
  }

  addNewItem(addNewItemType) {
    this.setState({ addNewItemType }, this.toggleDrawer);
  }

  render() {
    const data = this.state.data;
    const { edit } = this.props;

    return (
      <CRUD
        tabsData={[
          {
            name: "AGENT",
            renderedComponent: (
              <AgentInfo
                data={data}
                handleChangeInput={this.handleChangeInput}
                handleChangeDropdown={this.handleChangeDropdown}
                viewMode={this.state.viewMode}
                deleted={data && data.DELETED === "1"}
                addNewItem={this.addNewItem}
                newFirm={this.state.newFirm}
              />
            ),
          },
        ]}
        backLink={`${arc.path.base}agents`}
        edit={edit}
        state={this.state}
        setState={this.setState.bind(this)}
        handleSubmit={this.handleSubmit}
        saveData={this.saveData}
        type="agent"
        backName="AGENTS"
        title={data && `${data.FIRST_NAME} ${data.LAST_NAME}`}
        drawer={
          <Drawer
            isOpen={this.state.showDrawer}
            shouldDisplayChildDrawer={true}
            reff={this.drawerComponentRef}
            closeDrawer={this.closeDrawer}
          >
            <FirmDrawer
              savedNewItem={this.savedNewFirm}
              closeDrawer={this.closeDrawer}
            />
          </Drawer>
        }
      />
    );
  }
}
